export async function createUrl(): Promise<string> {
  try {
    const envApi = process.env.REACT_APP_API_URL?.replace(/\/$/, "");
    if (envApi) {
      return new URL(envApi).href;
    }

    let baseUrl = window.location.origin.replace("3000", "4000");
    if (!baseUrl.includes("localhost")) {
      baseUrl = `${baseUrl}/api`;
    }

    return new URL(baseUrl).href;
  } catch {
    throw new Error("Url creating error");
  }
}
